import React from 'react';
import { everyTokenStyle as styles } from './everyToken.tailwind';
import falconsImg from '../../../assets/images/falcons.png';
import falconsBallImg from '../../../assets/images/falcons_ball.png';

const EveryToken = () => {
  return (
    <section className={styles.section_wrapper}>
      <div className={styles.container}>
        {/* Left Column: Overlapping Images */}
        <div className={styles.image_container}>
          <img 
            src={falconsImg} 
            alt="CHOA Child and Mother" 
            className={styles.main_image} 
          />
          <img 
            src={falconsBallImg} 
            alt="Atlanta Falcons Football Game Catch" 
            className={styles.overlap_image} 
          />
        </div>

        {/* Right Column: Copywriting */}
        <div className={styles.text_container}>
          <h2 className={styles.heading}>
            EVERY TOKEN<br />
            IS A KID'S<br />
            TOMORROW.
          </h2>
          
          <div className={styles.divider} />

          <p className={styles.description}>
            Children's Healthcare of Atlanta is one of the largest pediatric clinical care providers in the country. From cancer treatment to emergency care to cutting-edge research, CHOA serves more than a million kid visits each year — many from families who can't afford it.
          </p>

          <div className={styles.testimonial_container}>
            <blockquote className={styles.quote_text}>
              "When my son was at CHOA, the Falcons came to visit him. He hasn't stopped smiling since. Knowing fans are funding this — it means everything."
            </blockquote>
            <cite className={styles.citation}>
              — MARIA R., CHOA FAMILY
            </cite>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EveryToken;
